/**
 * Presell page sticky bar (sections/afroyla-seen-sticky.liquid).
 *
 * It mirrors the buy box by READING its DOM — never by touching
 * assets/afroyla-seen-buy.js:
 *   names  ← [data-buy-card][aria-checked="true"] → its picked thumbs
 *   save   ← the money inside [data-buy-save]      pay ← [data-buy-total]
 *   button ← a[data-buy-checkout] (label + cart permalink), copied live
 *
 * No coupon code, no localStorage. Two gates: nothing over the hero, and
 * nothing while #seen-buy holds 0.15+ of the viewport — the shopper reading the
 * buy box is never given a second, smaller copy of its button.
 */
(function () {
  'use strict';

  if (window.__aflSeenStickyInit) return;
  window.__aflSeenStickyInit = true;

  var FOLD_FALLBACK = 500; // px scrolled before the bar may appear, if no fold
  var NARROW = 380; // below this the names are dropped, the saving stays

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function fill(tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (whole, key) {
      return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : whole;
    });
  }

  function text(el) {
    return el ? (el.textContent || '').trim() : '';
  }

  /** "You save $207.94 · 55%" → "$207.94". The money format is the shop's, never typed here. */
  function moneyIn(s) {
    var m = String(s || '').match(/[^\s·]*\d[\d.,]*/);
    return m ? m[0] : '';
  }

  /** The selected card's designs, duplicates collapsed: "Kora ×2 + Dunia". */
  function pickedNames(buy) {
    var card = buy.querySelector('[data-buy-card][aria-checked="true"]');
    if (!card) return '';
    var groups = [];
    card.querySelectorAll('[data-card-picks] [role="radio"][aria-checked="true"]').forEach(function (thumb) {
      var name = text(thumb.querySelector('.afl-buy__th-n')) || text(thumb);
      if (!name) return;
      var found = groups.filter(function (g) {
        return g.name === name;
      })[0];
      if (found) found.count += 1;
      else groups.push({ name: name, count: 1 });
    });
    return groups
      .map(function (g) {
        return g.count > 1 ? g.name + ' ×' + g.count : g.name;
      })
      .join(' + ');
  }

  function Bar(bar, buy) {
    this.bar = bar;
    this.buy = buy;
    this.label = bar.querySelector('[data-seen-sticky-label]');
    this.btn = bar.querySelector('[data-seen-sticky-btn]');
    this.fold = document.querySelector('.afl-seen-fold');
    this.touched = false; // a card or a pick was changed
    this.past = false; // the buy box's top is above the viewport top
    this.onScreen = true; // any part of the buy box is visible
    this.gate = false; // the hero has been scrolled past
    this.queued = false;
  }

  Bar.prototype.paint = function () {
    this.queued = false;
    var bar = this.bar;
    var checkout = this.buy.querySelector('[data-buy-checkout]');

    if ((this.touched || this.past) && checkout) {
      var save = moneyIn(text(this.buy.querySelector('[data-buy-save]')));
      var names = pickedNames(this.buy);
      var tpl = bar.getAttribute('data-label-after') || '{names} · you save {save}';
      // Narrow phones (and a set with no names to show) drop the names, never the money.
      if (window.innerWidth < NARROW || !names) tpl = tpl.replace(/\{names\}\s*[·|—-]?\s*/, '');
      var line = fill(tpl, {
        // The names are the shrinkable part: they ellipsise, the money never does.
        names: names ? '<span class="afl-seen-sticky__names">' + esc(names) + '</span>' : '',
        save: save ? '<b class="afl-seen-sticky__save">' + esc(save) + '</b>' : '',
        pay: esc(text(this.buy.querySelector('[data-buy-total]'))),
      });
      if (this.label) this.label.innerHTML = line.replace(/^\s*[·|—-]\s*/, '');
      // 06.09: the buy button is two spans (label / total) — mirror them as-is
      if (checkout.querySelector('.afl-buy__btn-l')) this.btn.innerHTML = checkout.innerHTML;
      else this.btn.textContent = text(checkout);
      this.btn.setAttribute('href', checkout.getAttribute('href') || '/cart');
      bar.setAttribute('data-state', 'after');
    } else {
      if (this.label) this.label.textContent = bar.getAttribute('data-label-before') || '';
      this.btn.textContent = bar.getAttribute('data-cta-before') || '';
      this.btn.setAttribute('href', '#seen-buy');
      bar.setAttribute('data-state', 'before');
    }

    var show = this.gate && !this.onScreen;
    bar.hidden = false;
    bar.setAttribute('data-visible', show ? 'true' : 'false');
    document.documentElement.classList.toggle('afl-seen-sticky-on', show);
  };

  Bar.prototype.schedule = function () {
    if (this.queued) return;
    this.queued = true;
    window.requestAnimationFrame(this.paint.bind(this));
  };

  /** One measure for both scroll gates — the desktop theme scrolls .page-wrapper.
      "Past" is the SIGN of the buy box's top, not its bottom: a bottom of 0.4px
      after an anchor jump is still past, and the sign can never be ambiguous. */
  Bar.prototype.measure = function () {
    this.past = this.buy.getBoundingClientRect().top < 0;
    this.gate = this.fold
      ? this.fold.getBoundingClientRect().bottom <= 0
      : (window.scrollY || document.documentElement.scrollTop || 0) > FOLD_FALLBACK;
    this.schedule();
  };

  Bar.prototype.start = function () {
    var self = this;
    var onScroll = function () {
      self.measure();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });

    if ('IntersectionObserver' in window) {
      // 0.15 of the buy box, not a single pixel of it: the last sliver of the
      // panel (the fine print under its own button) must not keep the bar down.
      // The last entry wins — two thresholds can be crossed in one callback.
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        self.onScreen = e.isIntersecting && e.intersectionRatio >= 0.15;
        self.schedule();
      }, { threshold: [0, 0.15] }).observe(this.buy);
    } else {
      this.onScreen = false;
    }

    // The buy box repaints its cards, its receipt and its checkout link on every
    // change; watching it is enough to stay in step without owning its state.
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        self.schedule();
      }).observe(this.buy, { subtree: true, childList: true, characterData: true, attributes: true });
    }
    ['click', 'change'].forEach(function (type) {
      self.buy.addEventListener(type, function () {
        self.touched = true;
        self.schedule();
      }, true);
    });

    this.btn.addEventListener('click', function (event) {
      if (self.bar.getAttribute('data-state') === 'after') return; // straight to the permalink
      event.preventDefault();
      var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      self.buy.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    });

    this.measure();
  };

  function boot() {
    var bar = document.querySelector('[data-seen-sticky]');
    var buy = document.querySelector('#seen-buy');
    if (!bar || !buy || bar.__aflSeenSticky) return;
    bar.__aflSeenSticky = true;
    new Bar(bar, buy).start();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
